// Pure scrollspy helper. Given a list of heading rect descriptors
// `{ id, top }` in DOM order, return the id of the heading whose top
// is the last one at-or-above `threshold` (i.e., the heading the user
// has most recently scrolled past). Returns null for an empty input.
//
// Edge case: if every rect is below threshold (we're scrolled to the
// very top, before any heading), return the first id — that's the
// "we're in the first section" answer the outline rail expects to
// display on initial paint.
export function pickActiveHeadingId(rects, threshold) {
  if (!rects || rects.length === 0) return null;
  let current = null;
  for (const r of rects) {
    if (r.top <= threshold) current = r.id;
    else break;
  }
  return current ?? rects[0].id;
}
